import Billing from '@components/LocalMerchant/MarketingCenter/Billing'
import BillingQuestion from '@components/LocalMerchant/MarketingCenter/BillingQuestion'
import SelectVersion from '@components/LocalMerchant/MarketingCenter/SelectVersion'
import ProDetail from '@components/LocalMerchant/MarketingCenter/MarketingDetail/ProDetail'
import PaymentOrderDetail from '@components/LocalMerchant/MarketingCenter/Market/PaymentDetail'
import JiaMengWaterMirror from '@components/JiaMeng/WaterMirror'
import JiaMengHeader from '@components/JiaMeng/Header/MarketingCenter'
import Purchase from '@components/LocalMerchant/MarketingCenter/Purchase'
import ShopProduct from '@components/LocalMerchant/MarketingCenter/ShopProduct'
import FlagshipPublicize from '@components/LocalMerchant/MarketingCenter/FlagshipPublicize'

import {
  LITE_APP_SHARE,
  MARKETING_CENTER_PATH,
  PRODUCT_INVITATION_CARD
} from '@constant'
import { asyncLoad, isStoreAccount } from '@util'
import React from 'react'
import { getLiteAppType } from '@components/LocalMerchant/LiteApp/util'
import ProductIntro from '@common/ProductIntro'
import JiaMeng from '@components/LocalMerchant/MarketingCenter/Market/AllService/JiaMeng'

// const AsyncMarket = asyncLoad(() =>
//   import('@components/LocalMerchant/MarketingCenter/Market')
// )

const AsyncMarketDetail = asyncLoad(() =>
  import('@components/LocalMerchant/MarketingCenter/MarketingDetail')
)
const AsyncMarketingPortal = asyncLoad(() =>
  import('@components/LocalMerchant/MarketingCenter/MarketingPortal')
)

const DeliverModule = asyncLoad(() =>
  import('@components/LocalMerchant/MarketingCenter/Deliver')
)
const MVModule = asyncLoad(() =>
  import('@components/LocalMerchant/MarketingCenter/MV')
)

const WeddingSite = asyncLoad(() =>
  import('@components/LocalMerchant/MarketingCenter/WeddingSite/Index')
)

export default {
  path: 'marketingCenter',
  component: JiaMengHeader,
  indexRoute: {
    onEnter(ns, replace) {
      replace(MARKETING_CENTER_PATH)
    }
  },
  childRoutes: [
    {
      path: 'detail/:productId(/:type)',
      component: props => {
        return <AsyncMarketDetail key={props.params.productId} {...props} />
      }
    },
    {
      path: 'proDetail/:productId',
      component: ProDetail,
      stat: '服务市场/店铺旗舰版'
    },
    {
      path: 'market',
      component: props => {
        return isStoreAccount() ? (
          <JiaMeng {...props} />
        ) : (
          <AsyncMarketingPortal {...props} />
        )
      },
      stat: '服务市场/首页'
    },
    // {
    //   path: 'marketPortal',
    //   component: AsyncMarketingPortal,
    //   stat: '服务市场/首页'
    // },
    {
      path: 'paymentDetail',
      component: PaymentOrderDetail,
      stat: '服务市场/订单详情'
    },
    {
      path: 'billing',
      component: Billing,
      stat: '支付订单/开票申请'
    },
    {
      path: 'billingQuestion',
      component: BillingQuestion,
      stat: '支付订单/开票申请/常见问题'
    },
    {
      path: 'selectVersion',
      component: SelectVersion,
      stat: '服务市场/小程序',
      onEnter: async (ns, replace) => {
        replace(
          '/localMerchant/marketingCenter/detail/65/' +
            (getLiteAppType() == LITE_APP_SHARE ? 2 : 1)
        )
      }
    },
    {
      path: 'waterMirror',
      component: JiaMengWaterMirror,
      stat: '营销工具/水镜'
    },
    {
      path: 'purchase',
      component: Purchase,
      stat: '服务市场/店铺产品/选择产品'
    },
    {
      path: 'shopProduct',
      // component: ShopProduct, //当添加子路由时这样写疑似不生效
      indexRoute: {
        component: ShopProduct
      },
      stat: '服务市场/店铺产品',
      childRoutes: [
        {
          path: 'activateCode',
          component: asyncLoad(() =>
            import('@components/LocalMerchant/MarketingCenter/ShopProduct/Old/ActivateCode')
          ),
          stat: '服务市场/店铺产品/使用激活码'
        },
        {
          path: 'copyActivationCode',
          component: asyncLoad(() =>
            import('@components/LocalMerchant/MarketingCenter/ShopProduct/Old/ActivateCode/Copy')
          ),
          stat: '服务市场/店铺产品/拷贝激活码'
        }
      ]
    },
    {
      path: 'successfullyOpened',
      component: asyncLoad(() =>
        import('@components/LocalMerchant/MarketingCenter/SuccessfullyOpened')
      )
    },
    {
      path: 'flagshipPublicize',
      component: FlagshipPublicize,
      stat: '服务市场/司仪个人旗舰版'
    },
    {
      path: 'DeliverModule',
      indexRoute: {
        component: DeliverModule
      },
      stat: '电子请帖',
      childRoutes: [
        {
          path: 'intro',
          component: props => (
            <ProductIntro {...props} id={PRODUCT_INVITATION_CARD} />
          )
        }
      ]
    },
    {
      path: 'MVModule',
      indexRoute: {
        component: MVModule
      },
      stat: '婚礼MV'
    },
    {
      path: 'wedding-site',
      component: WeddingSite,
      stat: '婚礼现场'
    }
  ]
}
